<template>
  <div>
    <a-form
      :form="form"
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 12 }"
      :colon="false"
      @submit="handleSubmit"
    >
      <!-- ===== 一、申请人基本信息 ===== -->
      <div class="title" style="margin-top: 0">一、申请人基本信息</div>
      <div class="wrapper">
        <a-row>
          <a-col :lg="24" :md="24" :sm="24">
            <a-form-item
              label="申请类型"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-radio-group
                v-decorator="[
                  'applyType',
                  {
                    initialValue: 'add',
                    rules: [{ required: true, message: '请选择！' }],
                  },
                ]"
                @change="onApplyTypeChange"
              >
                <a-radio
                  v-for="item in applyTypeList"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.name }}</a-radio
                >
              </a-radio-group>
            </a-form-item>
          </a-col>

          <!-- 变更/注销：选择用户弹窗（隐藏触发器，由申请类型切换时自动打开） -->
          <EmployeeSelector
            ref="employeeSelector"
            style="display: none"
            @change="onSelectUser"
          />

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="姓名">
              <a-input
                v-decorator="[
                  'name',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="性别">
              <a-radio-group
                v-decorator="[
                  'sex',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              >
                <a-radio
                  v-for="item in sex"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.name }}</a-radio
                >
              </a-radio-group>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="曾用名">
              <a-input v-decorator="['formerName']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="入职日期">
              <a-date-picker
                style="width: 100%"
                placeholder=""
                v-decorator="[
                  'entryDate',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="出生日期">
              <a-date-picker
                style="width: 100%"
                placeholder=""
                v-decorator="['birthday']"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="年龄">
              <a-button block style="text-align: left">{{
                getDateLength("birthday")
              }}</a-button>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="国籍(地区)">
              <a-input v-decorator="['nationality']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="民族">
              <a-input v-decorator="['ethnicGroup']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="政治面貌">
              <a-select v-decorator="['political']" :allowClear="true">
                <a-select-option
                  v-for="item in politicalOutlookList"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="入党/团日期">
              <a-date-picker
                style="width: 100%"
                placeholder=""
                v-decorator="['politicalDate']"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </div>

      <!-- ===== 二、权限信息 ===== -->
      <div class="title">二、权限信息</div>
      <div class="wrapper">
        <a-row>
          <a-col :lg="24" :md="24" :sm="24">
            <a-form-item
              label="权限需求描述"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-textarea
                :auto-size="{ minRows: 3 }"
                v-decorator="['permissionDesc']"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </div>

      <!-- ===== 三、证件信息 ===== -->
      <div class="title">三、证件信息</div>
      <div class="wrapper">
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="证件类型">
              <a-select v-decorator="['credentialType']" :allowClear="true">
                <a-select-option
                  v-for="item in credentialType"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="证件截止日期">
              <a-date-picker
                style="width: 100%"
                placeholder=""
                v-decorator="['credentialExpiryDate']"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="24" :md="24" :sm="24">
            <a-form-item
              label="证件号码"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-input v-decorator="['credentialNo']" />
            </a-form-item>
          </a-col>
        </a-row>
      </div>

      <!-- ===== 四、户籍与居住信息 ===== -->
      <div class="title">四、户籍与居住信息</div>
      <div class="wrapper">
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="籍贯">
              <a-input v-decorator="['nativePlace']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="户口类型">
              <a-select
                v-decorator="['registerResidenceType']"
                :allowClear="true"
              >
                <a-select-option
                  v-for="item in registerResidenceType"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="24" :md="24" :sm="24">
            <a-form-item
              label="户籍地址"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-input v-decorator="['registeredAddress']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="出生地">
              <a-input v-decorator="['birthPlace']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="家庭地址">
              <a-input v-decorator="['address']" />
            </a-form-item>
          </a-col>

          <a-col :lg="24" :md="24" :sm="24">
            <a-form-item
              label="办公地址"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-input v-decorator="['addressWork']" />
            </a-form-item>
          </a-col>
        </a-row>
      </div>

      <!-- ===== 五、档案信息 ===== -->
      <div class="title">五、档案信息</div>
      <div class="wrapper">
        <a-row>
          <a-col :lg="24" :md="24" :sm="24">
            <a-form-item
              label="档案所在地"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-input v-decorator="['archiveLocation']" />
            </a-form-item>
          </a-col>

          <a-col :lg="24" :md="24" :sm="24">
            <a-form-item
              label="档案存档机构"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-input v-decorator="['archiveOrganization']" />
            </a-form-item>
          </a-col>
        </a-row>
      </div>

      <!-- ===== 六、职业与教育背景 ===== -->
      <div class="title">六、职业与教育背景</div>
      <div class="wrapper">
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="最高学历">
              <a-select v-decorator="['degree']" :allowClear="true">
                <a-select-option
                  v-for="item in degree"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="专业特长">
              <a-input v-decorator="['expertises']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="参加工作日期">
              <a-date-picker
                style="width: 100%"
                placeholder=""
                v-decorator="[
                  'workStartTime',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="工号">
              <a-input v-decorator="['jobNumber']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="部门">
              <a-select
                show-search
                :filter-option="$selectFilterOption"
                v-decorator="[
                  'belongDept',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                :allowClear="true"
              >
                <a-select-option
                  v-for="item in organizationList"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.uniqueName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="岗位">
              <a-select v-decorator="['position']" :allowClear="true">
                <a-select-option
                  v-for="item in positionList"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </div>

      <!-- ===== 七、联系方式 ===== -->
      <div class="title">七、联系方式</div>
      <div class="wrapper">
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="手机号码">
              <a-input
                v-decorator="[
                  'mobile',
                  {
                    rules: [
                      { required: true, message: '请输入！' },
                      {
                        pattern: /^1\d{10}$/,
                        message: '请输入正确的手机号码！',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="办公电话">
              <a-input v-decorator="['phone']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="公司邮箱">
              <a-input
                v-decorator="[
                  'email',
                  {
                    rules: [
                      { required: true, message: '请输入！' },
                      {
                        type: 'email',
                        message: '请输入正确的邮箱！',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="个人邮箱">
              <a-input
                v-decorator="[
                  'emailIndividual',
                  {
                    rules: [{ type: 'email', message: '请输入正确的邮箱！' }],
                  },
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="门户账号">
              <a-input
                v-decorator="[
                  'portalAccount',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </div>

      <!-- ===== 八、家庭与社会关系 ===== -->
      <div class="title">八、家庭与社会关系</div>
      <div class="wrapper">
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="婚姻状况">
              <a-select v-decorator="['marryType']" :allowClear="true">
                <a-select-option
                  v-for="item in marrigeStatus"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="子女状况">
              <a-select v-decorator="['childrenType']" :allowClear="true">
                <a-select-option
                  v-for="item in childStatus"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="紧急联系人姓名">
              <a-input
                v-decorator="[
                  'emergencyContact',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="紧急联系人关系">
              <a-input v-decorator="['emergencyContactRelation']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="紧急联系人电话">
              <a-input
                v-decorator="[
                  'emergencyContactMobile',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </div>

      <div class="footer">
        <a-space>
          <a-button
            htmlType="submit"
            type="primary"
            :loading="loading"
            >保存</a-button>
          <a-button @click="handleClose">关闭</a-button>
        </a-space>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import EmployeeSelector from "@/components/employee-selector";
import { fetchDetail as fetchTalentDetail } from "@/api/human-resources/employee";
import organization from "@/mixins/organization";

export default {
  name: "BranchEmployeeAccountForm",

  components: {
    EmployeeSelector,
  },

  mixins: [organization],

  props: {
    // 详情数据（用于查看详情）
    detailData: { type: Object, default: null },
    // 编辑时的原始数据（用于编辑模式）
    editData: { type: Object, default: null },
  },

  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      applyType: "add",
      selectedUser: {},
      applyTypeList: [
        { name: "新增", value: "add" },
        { name: "变更", value: "update" },
        { name: "注销", value: "leave" },
      ],
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),

    // 是否为详情模式
    isDetail() {
      return !!this.detailData;
    },

    // 原始数据（编辑模式用 editData，详情模式用 detailData）
    sourceData() {
      return this.editData || this.detailData;
    },

    // talentMap 字典组
    lists() {
      return this.findDataDict("talentMap");
    },

    sex() {
      return this.findDataDict("sex");
    },
    // 政治面貌
    politicalOutlookList() {
      return this.findDataDict("politicalOutlook");
    },
    // 学历
    degree() {
      return this.findDataDict("degree");
    },
    // 岗位
    positionList() {
      const item = (this.lists || []).find(
        (item) => item.value === "talentMap_post"
      );
      return item ? item.children : [];
    },
    // 证件类型
    credentialType() {
      const item = (this.lists || []).find(
        (item) => item.value === "credentialType"
      );
      return item ? item.children : [];
    },
    // 户口类型
    registerResidenceType() {
      const item = (this.lists || []).find(
        (item) => item.value === "registerResidenceType"
      );
      return item ? item.children : [];
    },
    // 婚姻状况
    marrigeStatus() {
      const item = (this.lists || []).find(
        (item) => item.value === "marrigeStatus"
      );
      return item ? item.children : [];
    },
    // 子女状况
    childStatus() {
      const item = (this.lists || []).find(
        (item) => item.value === "childStatus"
      );
      return item ? item.children : [];
    },
  },

  watch: {
    // 编辑/详情数据（异步到达时）变化后重新回填
    sourceData: {
      handler() {
        this.initFormData();
      },
      immediate: true,
    },
  },

  methods: {
    // 申请类型切换
    onApplyTypeChange(e) {
      this.applyType = e.target.value;
      // 变更/注销：弹出选择用户弹窗
      if (this.applyType === "update" || this.applyType === "leave") {
        if (this.$refs.employeeSelector) {
          this.$refs.employeeSelector.add();
        }
      }
    },

    // 选择用户回调
    onSelectUser(arr) {
      if (arr.length > 0) {
        this.selectedUser = arr[0];
        // 变更/注销：根据所选用户 id 调用 /user-service/talentMap/query/{id} 加载档案并回填
        if (!this.isDetail) {
          this.loadTalentDetail(arr[0].id);
        }
      } else {
        this.selectedUser = {};
      }
    },

    // 调用 /user-service/talentMap/query/{id} 加载人才档案并回填表单
    loadTalentDetail(id) {
      if (!id) return;
      fetchTalentDetail({ id }).then((res) => {
        if (!res) return;
        // 证件信息在 credentialList 数组中，取第一条
        const cred =
          Array.isArray(res.credentialList) && res.credentialList.length > 0
            ? res.credentialList[0]
            : {};
        // 紧急联系人关系：取家庭及主要社会关系中的第一条关系
        const relative =
          Array.isArray(res.relativeList) && res.relativeList.length > 0
            ? res.relativeList[0]
            : {};
        this.form.setFieldsValue({
          name: res.name,
          sex: res.sex,
          formerName: res.oldName,
          birthday: res.birthday ? moment(res.birthday) : undefined,
          nationality: res.nationality,
          ethnicGroup: res.ethnicGroup,
          political: res.political,
          politicalDate: res.politicalDate
            ? moment(res.politicalDate)
            : undefined,
          nativePlace: res.nativePlace,
          entryDate: res.entryDate ? moment(res.entryDate) : undefined,
          degree: res.degree,
          expertises: res.expertises,
          workStartTime: res.workStartTime
            ? moment(res.workStartTime)
            : undefined,
          marryType: res.marryType,
          childrenType: res.childrenType,
          credentialType: cred.type,
          credentialNo: cred.number,
          credentialExpiryDate: cred.expireDate
            ? moment(cred.expireDate)
            : undefined,
          registerResidenceType: res.registerResidenceType,
          registeredAddress: res.registerResidenceAddress,
          birthPlace: res.birthplace,
          address: res.address,
          addressWork: res.addressWork,
          archiveLocation: res.archiveLocation,
          archiveOrganization: res.archiveAgency,
          jobNumber: res.workNo,
          mobile: res.mobile,
          phone: res.phone,
          email: res.email,
          emailIndividual: res.emailIndividual,
          portalAccount: res.code || res.portalAccount,
          position: res.position ? res.position.position : undefined,
          belongDept: res.position ? res.position.belongDept : undefined,
          emergencyContact: res.emergencyContact,
          emergencyContactRelation: relative.type,
          emergencyContactMobile: res.emergencyContactMobile,
        });
      });
    },

    // 根据日期字段计算年限（用于年龄只读展示）
    getDateLength(key) {
      const str = this.form.getFieldValue(key);
      if (str && str.format) {
        const year = new Date().getFullYear();
        return year - parseInt(str.format("YYYY"));
      } else {
        return "";
      }
    },

    // 日期统一格式化为 YYYY-MM-DD
    formatDate(value) {
      if (!value) return undefined;
      if (moment.isMoment(value)) {
        return value.format("YYYY-MM-DD");
      }
      // 字符串统一转 moment 再格式化，避免格式不一致
      const m = moment(value);
      return m.isValid() ? m.format("YYYY-MM-DD") : value;
    },

    // 初始化表单数据（编辑 / 详情）
    initFormData() {
      const data = this.sourceData;
      if (!data || Object.keys(data).length === 0) return;

      this.applyType = data.applicationType || "add";

      this.selectedUser = data.targetUserId
        ? { userId: data.targetUserId, name: data.targetUserName }
        : {};

      if (!this.isDetail) {
        this.$nextTick(() => {
          this.form.setFieldsValue({
          applyType: data.applicationType,
          name: data.name,
          sex: data.sex,
          formerName: data.oldName,
          entryDate: data.entryDate ? moment(data.entryDate) : undefined,
          birthday: data.birthday ? moment(data.birthday) : undefined,
          nationality: data.nationality,
          ethnicGroup: data.ethnicGroup,
          political: data.political,
          politicalDate: data.politicalDate
            ? moment(data.politicalDate)
            : undefined,
          permissionDesc: data.permissionDescription,
          credentialType: data.credentialType,
          credentialNo: data.credentialNumber,
          credentialExpiryDate: data.credentialExpireDate
            ? moment(data.credentialExpireDate)
            : undefined,
          nativePlace: data.nativePlace,
          registerResidenceType: data.registerResidenceType,
          registeredAddress: data.registerResidenceAddress,
          birthPlace: data.birthplace,
          address: data.address,
          addressWork: data.addressWork,
          archiveLocation: data.archiveLocation,
          archiveOrganization: data.archiveAgency,
          degree: data.degree,
          expertises: data.expertises,
          workStartTime: data.workStartTime
            ? moment(data.workStartTime)
            : undefined,
          jobNumber: data.workNo,
          belongDept: data.deptId,
          position: data.post,
          mobile: data.mobile,
          phone: data.phone,
          email: data.email,
          emailIndividual: data.emailIndividual,
          portalAccount: data.code,
          marryType: data.marryType,
          childrenType: data.childrenType,
          emergencyContact: data.emergencyContact,
          emergencyContactRelation: data.emergencyContactRelation,
          emergencyContactMobile: data.emergencyContactMobile,
        });
        });
      }
    },

    // 构建提交数据
    buildPayload(values) {
      // 部门名称：根据所选部门 id 从组织列表中取
      const dept = (this.organizationList || []).find(
        (item) => item.id === values.belongDept
      );

      return {
        id: this.sourceData ? this.sourceData.id : undefined,
        applicationType: values.applyType,
        name: values.name,
        sex: values.sex,
        oldName: values.formerName,
        birthday: this.formatDate(values.birthday),
        nationality: values.nationality,
        ethnicGroup: values.ethnicGroup,
        political: values.political,
        politicalDate: this.formatDate(values.politicalDate),
        entryDate: this.formatDate(values.entryDate),
        permissionDescription: values.permissionDesc,
        credentialType: values.credentialType,
        credentialNumber: values.credentialNo,
        credentialExpireDate: this.formatDate(values.credentialExpiryDate),
        nativePlace: values.nativePlace,
        registerResidenceType: values.registerResidenceType,
        registerResidenceAddress: values.registeredAddress,
        birthplace: values.birthPlace,
        address: values.address,
        addressWork: values.addressWork,
        archiveLocation: values.archiveLocation,
        archiveAgency: values.archiveOrganization,
        degree: values.degree,
        expertises: values.expertises,
        workStartTime: this.formatDate(values.workStartTime),
        workNo: values.jobNumber,
        deptId: values.belongDept,
        deptName: dept ? dept.uniqueName : undefined,
        post: values.position,
        mobile: values.mobile,
        phone: values.phone,
        email: values.email,
        emailIndividual: values.emailIndividual,
        code: values.portalAccount,
        marryType: values.marryType,
        childrenType: values.childrenType,
        emergencyContact: values.emergencyContact,
        emergencyContactRelation: values.emergencyContactRelation,
        emergencyContactMobile: values.emergencyContactMobile,
      };
    },

    // 验证并获取表单数据
    validateAndGetData(callback) {
      // 变更/注销必须选择用户
      if (
        (this.applyType === "update" || this.applyType === "leave") &&
        !this.selectedUser.userId
      ) {
        // this.$message.error("请选择用户");
        // return;
      }
      this.form.validateFields((err, values) => {
        if (err) {
          return;
        }
        const payload = this.buildPayload(values);
        callback(payload);
      });
    },

    handleSubmit(e) {
      e.preventDefault();
      this.validateAndGetData((payload) => {
        this.$emit("submit", payload);
      });
    },

    handleClose() {
      this.$emit("close");
    },

    // 外部调用：设置加载状态
    setLoading(loading) {
      this.loading = loading;
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  background-color: #f9f9f9;
  padding-top: 24px;
  padding-bottom: 8px;
  margin-bottom: 10px;
}

.title {
  font-weight: bold;
  font-size: 17px;
  margin: 12px 0;
}

.footer {
  padding: 80px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
